import { queryKeys } from "../queryKeys";
import {
  type CryptoMonthlyVolume,
  getCryptoMonthlyVolume,
} from "../rest/billing";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetCryptoMonthlyVolume = ({
  accountID,
  options,
}: {
  accountID?: string;
  options?: QueryOptions<CryptoMonthlyVolume>;
}) => {
  const { data } = useRequest(
    queryKeys.crypto.monthlyVolume(accountID || ""),
    () => getCryptoMonthlyVolume(accountID || ""),
    {
      enabled: !!accountID,
      ...options,
    },
  );

  return { ...data };
};

export default useGetCryptoMonthlyVolume;
